import restapi from 'utils/restapi';
import { addLang } from "utils/addLang";

import { baseErrorsHandlerDecorator } from 'redux/utils';

import {
  FETCH_CATALOG_PRODUCTS_LIST_SUCCESS,
  FETCH_CATALOG_PRODUCTS_LIST_ERROR,
  CLEAR_FETCH_CATALOG_PRODUCTS_LIST,
  APPLY_PRODUCT_DRAG_SUCCESS,
  APPLY_PRODUCT_DRAG_ERROR,
  CLEAR_PRODUCT_DRAG,
  ADD_PRODUCT_LINK_SUCCESS,
  ADD_PRODUCT_LINK_ERROR,
  CLEAR_ADD_PRODUCT_LINK,
  DELETE_PRODUCT_LINK_SUCCESS,
  DELETE_PRODUCT_LINK_ERROR,
  CLEAR_DELETE_PRODUCT_LINK,
  PATCH_PRODUCT_LINK_SUCCESS,
  PATCH_PRODUCT_LINK_ERROR,
  CLEAR_PATCH_PRODUCT_LINK,
  FETCH_CATALOG_DESCRIPTION_SUCCESS,
  FETCH_CATALOG_DESCRIPTION_ERROR,
  CLEAR_FETCH_CATALOG_DESCRIPTION,
  PATCH_CATALOG_DESCRIPTION_SUCCESS,
  PATCH_CATALOG_DESCRIPTION_ERROR,
  CLEAR_PATCH_CATALOG_DESCRIPTION,
} from 'redux/catalog/types';


export const fetchCatalogProductsList = () => baseErrorsHandlerDecorator(
  FETCH_CATALOG_PRODUCTS_LIST_SUCCESS,
  FETCH_CATALOG_PRODUCTS_LIST_ERROR,
  () => restapi.get(addLang('links/product_links/')),
  false,
);

export const clearCatalogProductsList = () => dispatch => {
  dispatch({
    type: CLEAR_FETCH_CATALOG_PRODUCTS_LIST,
  });
};

export const applyProductDrag = formData => baseErrorsHandlerDecorator(
  APPLY_PRODUCT_DRAG_SUCCESS,
  APPLY_PRODUCT_DRAG_ERROR,
  () => restapi.post(addLang('links/product_links/ordering/'), formData),
  false,
  true /* actionSucces */,
);

export const clearProductDrag = () => dispatch => {
  dispatch({
    type: CLEAR_PRODUCT_DRAG,
  });
};

export const addProductLink = url => baseErrorsHandlerDecorator(
  ADD_PRODUCT_LINK_SUCCESS,
  ADD_PRODUCT_LINK_ERROR,
  () => restapi.post(addLang('links/product_links/'), { url }),
  false,
  true /* actionSucces */,
);

export const clearAddProductLink = () => dispatch => {
  dispatch({
    type: CLEAR_ADD_PRODUCT_LINK,
  });
};

export const deleteProductLink = linkId => baseErrorsHandlerDecorator(
  DELETE_PRODUCT_LINK_SUCCESS,
  DELETE_PRODUCT_LINK_ERROR,
  () => restapi.delete(addLang(`links/product_links/${linkId}/`)),
  false,
  true /* actionSucces */,
);

export const clearDeleteProductLink = () => dispatch => {
  dispatch({
    type: CLEAR_DELETE_PRODUCT_LINK,
  });
};

export const patchProductLink = (linkId, formData) => baseErrorsHandlerDecorator(
  PATCH_PRODUCT_LINK_SUCCESS,
  PATCH_PRODUCT_LINK_ERROR,
  () => restapi.patch(addLang(`links/product_links/${linkId}/`), formData),
  false,
  true /* actionSucces */,
);

export const clearPatchProductLink = () => dispatch => {
  dispatch({
    type: CLEAR_PATCH_PRODUCT_LINK,
  });
};

export const fetchCatalogDescription = () => baseErrorsHandlerDecorator(
  FETCH_CATALOG_DESCRIPTION_SUCCESS,
  FETCH_CATALOG_DESCRIPTION_ERROR,
  () => restapi.get(addLang('users/store_link/')),
  false,
);

export const clearFetchCatalogDescription = () => dispatch => {
  dispatch({
    type: CLEAR_FETCH_CATALOG_DESCRIPTION,
  });
};

export const patchCatalogDescription = (catalogId, formData) => baseErrorsHandlerDecorator(
  PATCH_CATALOG_DESCRIPTION_SUCCESS,
  PATCH_CATALOG_DESCRIPTION_ERROR,
  () => restapi.patch(addLang(`users/store_link/${catalogId}/update/`), formData),
  false,
  true /* actionSucces */,
);

export const clearPatchCatalogDescription = () => dispatch => {
  dispatch({
    type: CLEAR_PATCH_CATALOG_DESCRIPTION,
  });
};
